import { render, staticRenderFns } from "./glovo_order_products.vue?vue&type=template&id=6b35ccd6&scoped=true&"
import script from "./glovo_order_products.vue?vue&type=script&lang=js&"
export * from "./glovo_order_products.vue?vue&type=script&lang=js&"
import style0 from "./glovo_order_products.vue?vue&type=style&index=0&id=6b35ccd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35ccd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b35ccd6')) {
      api.createRecord('6b35ccd6', component.options)
    } else {
      api.reload('6b35ccd6', component.options)
    }
    module.hot.accept("./glovo_order_products.vue?vue&type=template&id=6b35ccd6&scoped=true&", function () {
      api.rerender('6b35ccd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/glovo/location/tabs/glovo_order_products.vue"
export default component.exports